import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { Subscription } from 'rxjs';

import { EUserPermissions } from '../../../chat/interfaces/EPermissions';
import { ChannelFeatures, ChannelRoles, ChannelType } from '../../../chat/interfaces/IChannel';
import { DealerSettingName } from '../../../chat/interfaces/IDealerSettings';
import { WorkspaceFeatures } from '../../../chat/interfaces/IWorkspace';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export abstract class BaseComponent implements OnDestroy {
  private subscriptions = new Subscription();

  protected addSubscription(subscription: Subscription): void {
    this.subscriptions.add(subscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get WorkspaceFeatures(): typeof WorkspaceFeatures {
    return WorkspaceFeatures;
  }

  get ChannelFeatures(): typeof ChannelFeatures {
    return ChannelFeatures;
  }

  get ChannelRoles(): typeof ChannelRoles {
    return ChannelRoles;
  }

  get ChannelType(): typeof ChannelType {
    return ChannelType;
  }

  get DealerSettingName(): typeof DealerSettingName {
    return DealerSettingName;
  }

  get EUserPermissions(): typeof EUserPermissions {
    return EUserPermissions;
  }
}
